import { apiGet } from 'ApiPackage/MainModule/common/apiTools';
import { config } from 'CorePackage/MainModule/constants/config';

import { IGetNews } from '../interfaces/IGetNews';
import { INewsResponse } from '../interfaces/INewsResponse';

export async function getNews({ size = undefined, type = undefined }: IGetNews): Promise<INewsResponse> {
  const params = new URLSearchParams();
  if (type !== undefined) {
    params.set('type', type);
  }
  params.set('sort', 'published,desc');
  if (size !== undefined) {
    params.set('size', size.toString());
  }

  return apiGet<INewsResponse>(`${config.server}/news?${params}`);
}
